module.exports = __webpack_public_path__ + "static/media/thinking-react.b2ee2d6c.png";